import React, { useEffect, useState } from "react";
import { IonSpinner } from "@ionic/react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { CancelOutlined } from "@mui/icons-material";
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import "./FAQ.scss"
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LogoutIcon from '@mui/icons-material/Logout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import API from "../../../services";


const FAQ: React.FC = () => {





  const [loading, setLoading] = useState<boolean>(false);
  const [FAQData, setFAQData] = useState<any>(null);
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const getFAQInfo = async () => {
    setLoading(true);

    let response;
    try {
      response = await API.post(`/webapp/get-content`, {
        tag: "FAQ"
      });
    } catch (e) {
      console.log(e);
      setLoading(false);
      return;
    }

    if (response.data.status !== "RS_OK") {
      navigate("/home");
    }

    if (response && response.data?.data) {
      setFAQData(response.data?.data);
      if (FAQData) {
        faqRules();
      }
    }
    setLoading(false);
  };

  const faqRules = async () => {
    try {
      let contentElement = document.getElementById("content");
      if (contentElement) {
        contentElement.innerHTML = `${FAQData || "<div></div>"}`;
      } else {
        console.error("Element with ID 'content' not found.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (FAQData) {
      faqRules();
    }
  }, [FAQData]);

  useEffect(() => {
    getFAQInfo();
  }, []);




  return (
    <>
      <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] text-white faq">
        <header className="flex gap-3 items-center self-start text-base font-medium text-center text-white mb-[0.5rem]">
        <div>
            <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                onClick={() => handleBackClick()}
            >
                <ArrowBackIcon
                    className="text-border-color aspect-square w-[18px]"
                    style={{ width: '20px', height: '20px' }}
                />
            </div>
        </div>
        <h1 className="text-[1.2rem] font-medium">Frequently Asked Questions (FAQ)</h1>
        </header>
        <div className="mt-2">
          <div className="content" id="content"></div>
        </div>
        <span
          className="text-blue-500 hover:underline cursor-pointer font-medium active:opacity-70"
          onClick={() => navigate("/wager-list")}
        >
          Clicking here</span>
      </div>
    </>
  );
};

export default FAQ;
